module.exports = __webpack_public_path__ + "static/Header3-e8a5820d21a6ccee09c8d96fd4517745.jpg";